import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
interface PhoneFrameProps {
  children: React.ReactNode;
  side?: React.ReactNode;
  onExit: () => void;
}

/** Presents a mobile app inside a device frame on desktop; full-screen on small viewports. */
export function PhoneFrame({
  children,
  side,
  onExit
}: PhoneFrameProps) {
  return <div className="min-h-full w-full bg-[#E3EBF2] lg:py-6" data-id="element-773" data-mp="3u3giukh2rty7">
      <div className="mx-auto flex max-w-[1100px] justify-center gap-10" data-id="element-774" data-mp="3ffls39mmnznr">
        <div className="hidden lg:flex flex-col gap-3 w-[300px] pt-2" data-id="element-775" data-mp="3k6tzk04edaya">
          <button onClick={onExit} className="btn btn-outline self-start" data-id="element-776" data-mp="3k854w4dhqqri">
            <ArrowLeftIcon className="h-4 w-4" data-id="element-777" data-mp="36gqgfi0tdxd2" /> ডেমো হোম
          </button>
          {side}
        </div>
        <div className="relative w-full lg:w-[392px] h-[100dvh] lg:h-[820px] lg:rounded-[44px] lg:border-[11px] lg:border-[#14212E] lg:shadow-pop overflow-hidden bg-canvas flex flex-col" data-id="element-778" data-mp="3bf1rfw2uidwv">
          {children}
        </div>
      </div>
    </div>;
}